// API Configuration
// Use REACT_APP_API_URL from environment variables, fallback to localhost:5000
export const API_URL = process.env.REACT_APP_API_URL || 'http://localhost:5000';

